export default "__VITE_ASSET__efea0c94__"